const DotEmpty = ({fill, width = 4, style}: {fill: string; width?: number; style?: React.CSSProperties}) => (
  <svg
    style={style}
    width={width}
    height={width}
    viewBox="0 0 4 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label=""
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.99999 3.12C2.29704 3.12 2.58191 3.00202 2.79196 2.79197C3.00201 2.58192 3.11999 2.29704 3.11999 2C3.11999 1.70296 3.00201 1.41808 2.79196 1.20804C2.58191 0.998001 2.29704 0.880002 1.99999 0.880002C1.70295 0.880002 1.41807 0.998001 1.20804 1.20804C0.997994 1.41808 0.879994 1.70296 0.879994 2C0.879994 2.29704 0.997994 2.58192 1.20804 2.79197C1.41807 3.00202 1.70295 3.12 1.99999 3.12ZM1.99999 3.6C2.42434 3.6 2.83132 3.43143 3.13135 3.13136C3.43142 2.83133 3.59999 2.42435 3.59999 2C3.59999 1.57566 3.43142 1.16869 3.13135 0.868632C2.83132 0.568571 2.42434 0.400002 1.99999 0.400002C1.57565 0.400002 1.16868 0.568571 0.868624 0.868632C0.568563 1.16869 0.399994 1.57566 0.399994 2C0.399994 2.42435 0.568563 2.83133 0.868624 3.13136C1.16868 3.43143 1.57565 3.6 1.99999 3.6Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.48"
    />
  </svg>
)

export default DotEmpty

try{ DotEmpty.displayName ||= 'DotEmpty' } catch {}